export default window.ReactNativeWebView;